var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',{attrs:{"col":"12","xl":"12"}},[_c('GoogleMapLoader',{attrs:{"mapConfig":_vm.mapConfig,"apiKey":"AIzaSyA464qcmgzE7HTRTiN_m-09c9xeOb8LmsE","setGoogleMap":_vm.setGoogleMap}})],1),_c('Notify',{ref:"notifyDialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }